// // export const API_URL = "http://192.168.0.105:8080";
// // export const API_URL = "http://192.168.0.106:8080";
export const API_URL = "https://apilms.deetyasoft.com";  
// export const API_URL = "http://192.168.0.142:8080";    
// export const API_URL = "http://192.168.29.177:8080";                   
//export const API_URL = "https://node.eurofox.in/talkguru";
// export const API_URL = "http://localhost:8080"
